import { cn } from '@/lib/utils'
import type { FontAwesomeIcon, IconType } from '@ur-solutions/react-components'
import type { CSSProperties, MouseEventHandler } from 'react'

export interface FAIconProps {
  className?: string

  icon: FontAwesomeIcon
  type?: IconType

  cursor?: CSSProperties['cursor']
  fixedWidth?: boolean
  disabled?: boolean

  onClick?: MouseEventHandler<HTMLElement>
}

export function FAIcon({
  className,

  icon,
  type = 'regular',

  cursor,
  fixedWidth = false,
  disabled = false,

  onClick,
}: FAIconProps) {
  return (
    <i
      className={cn(`fa-${type} fa-${icon}`, fixedWidth && 'fa-fw', className)}
      style={{ cursor }}
      aria-hidden="true"
      onClick={evt => !disabled && onClick?.(evt)}
    />
  )
}
